import { getCategorySlug, createSlug } from './categoryUtils';
import { resolveProductCategorySelection } from '../admin/utils/resolveProductCategories';

function findCategoryById(allCategories, id) {
  if (!id) return null;
  const needle = String(id).trim();
  return (
    allCategories.find((c) => String(c._id || c.id).trim() === needle) || null
  );
}

function displayName(value, row) {
  if (row?.name) return row.name;
  if (value == null || value === '') return '';
  if (typeof value === 'object') return value.name || value.slug || '';
  const s = String(value).trim();
  if (/^[a-f0-9]{24}$/i.test(s)) return '';
  return s;
}

function slugForLevel(row, allCategories, fallbackLabel) {
  if (row) {
    const slug = getCategorySlug(row, allCategories);
    if (slug) return slug;
  }
  if (fallbackLabel) return createSlug(fallbackLabel);
  return '';
}

/**
 * Build ordered, clickable category levels for PDP: main → sub → children.
 */
export function buildProductCategoryLinks(product, allCategories = []) {
  if (!product) return [];

  const catalog = Array.isArray(allCategories) ? allCategories : [];
  const resolved = resolveProductCategorySelection(product, catalog);
  const links = [];
  const seen = new Set();

  const addLink = (id, fallbackLabel) => {
    if (!id) return;
    const key = String(id).trim();
    if (!key || seen.has(key)) return;
    const row = findCategoryById(catalog, key);
    const label = displayName(fallbackLabel, row);
    if (!label) return;
    const slug = slugForLevel(row, catalog, label);
    if (!slug) return;
    seen.add(key);
    links.push({ id: key, label, slug });
  };

  const subFallback =
    typeof product.subcategory === 'object'
      ? product.subcategory?.name
      : product.subcategory || resolved.subcategoryName;

  const childRaw = product.childrenCategory;
  const childFallback =
    typeof childRaw === 'object' ? childRaw?.name : childRaw || '';

  addLink(resolved.mainCategoryId, resolved.mainCategoryName || product.mainCategory);
  addLink(resolved.subcategoryId, subFallback);
  addLink(resolved.childrenCategoryId, childFallback);

  if (links.length === 0) {
    const cat = product.category;
    if (typeof cat === 'object' && cat) {
      addLink(cat._id || cat.id, cat.name || cat.slug);
    } else if (cat) {
      const label = displayName(cat, null);
      if (label) {
        links.push({
          id: label,
          label,
          slug: createSlug(label) || String(cat).toLowerCase(),
        });
      }
    }
    if (subFallback) {
      const subLabel = displayName(subFallback, null);
      if (subLabel && !links.some((l) => l.label.toLowerCase() === subLabel.toLowerCase())) {
        links.push({
          id: subLabel,
          label: subLabel,
          slug: createSlug(subLabel),
        });
      }
    }
  }

  return links;
}
